window.addEventListener('DOMContentLoaded', (event) => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl)
  const searchParams = url.searchParams;

  // クーポン一覧
  const couponsPath = /\/coupons/;
  if (couponsPath.test(currentUrl)) {
    const nearby = document.getElementById('nearby')
    const area = document.getElementById('area')
    const nearbyList = document.querySelector('.nearbyList')
    const areaList = document.querySelector('.areaList')

    const setParam = (value) => {
      searchParams.set('type', value)
      url.search = searchParams.toString()
      window.location.href = url.toString()
    }

    const deleteParam = () => {
      searchParams.delete('type')
      url.search = searchParams.toString()
      window.location.href = url.toString()
    }

    if (searchParams.has('type')) {
      const type = searchParams.get('type')
      if (type === 'area') {
        nearby.classList.remove('active')
        area.classList.add('active')
        nearbyList.style.display = 'none'
        areaList.style.display = 'block'

      } else if (type === 'nearby') {
        nearby.classList.add('active')
        area.classList.remove('active')
        nearbyList.style.display = 'block'
        areaList.style.display = 'none'
      }
    }

    // changeTab
    nearby.addEventListener('click', () => {
      setParam('nearby')
    })
    area.addEventListener('click', () => {
      deleteParam()
    })
  }

  // クーポン一覧または店舗クーポン一覧
  const shopCouponsPath = /\/shop\/\d+\/\d+\/coupon/;
  if (couponsPath.test(currentUrl) || shopCouponsPath.test(currentUrl)) {
    // アドレスバーの高さ分画面からはみ出る問題の対策
    setTimeout(() => {
      const useCouponButton = document.querySelectorAll('.couponsList .useCouponButton')
      const detailCouponButton = document.querySelectorAll('.couponsList .detailCouponButton')
      if (useCouponButton) {
        useCouponButton.forEach(button => {
          button.addEventListener('click', () => {
            setViewHeight()
          })
        })
      }
      if (detailCouponButton) {
        detailCouponButton.forEach(button => {
          button.addEventListener('click', () => {
            setViewHeight()
          })
        })
      }
    }, 1000)

    window.addEventListener('resize', () => {
      setViewHeight()
    })
  }
})

function setViewHeight() {
  const couponView = document.querySelector('.couponView')
  if (couponView) {
    if (navigator.userAgent.match(/iPhone|iPad|Android/)) {
      couponView.style.height = window.innerHeight + 'px'
    }
  }
}
